// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionHeader_container__RnN94"};